/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MisconfigurationViolationsByCloudProviderWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("MisconfigurationViolationsByCloudProviderWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return MisconfigurationViolationsByCloudProviderWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<MisconfigurationViolationsByCloudProviderWidgetConfiguration>): MisconfigurationViolationsByCloudProviderWidgetConfiguration {
        let obj = Object.assign(new MisconfigurationViolationsByCloudProviderWidgetConfiguration(), model);
        MisconfigurationViolationsByCloudProviderWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MisconfigurationViolationsByCloudProviderWidgetConfiguration>): MisconfigurationViolationsByCloudProviderWidgetConfiguration {
        if (!model) return null;
        return MisconfigurationViolationsByCloudProviderWidgetConfiguration.newInstance(<MisconfigurationViolationsByCloudProviderWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MisconfigurationViolationsByCloudProviderWidgetConfiguration) {
        if (!obj) return;

        models.MisconfigurationViolationsByCloudProviderWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MisconfigurationViolationsByCloudProviderWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MisconfigurationViolationsByCloudProviderWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
